import React, { Fragment, useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import './Login.css';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEyeSlash, faEye } from '@fortawesome/free-solid-svg-icons';
import { delete_cookie } from 'sfcookies';
import { TextField } from '@mui/material';
import useUtils from '../utiles/useUtiles';
import { ToastContainer } from 'react-toastify';
import FormErrorContainer from '../main/sections/shared/FormErrorContainer';
import Footer from '../main/components/Footer';

const ResetPassword: React.FC = ( ) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const { toastInstance, axiosRequest, loadingScreen, handleError, baseUrl } = useUtils();
    const toast = toastInstance();
    const axios = axiosRequest();
    
    const [confirmPassword, setConfirmPassword] = useState<string>( '' );
    const [password, setPassword] = useState<string>( '' );
    const [confirmPasswordError, setConfirmPasswordError] = useState<string>( '' );
    const [passwordError, setPasswordError] = useState<string>( '' );
    const [loading, setLoading] = useState<boolean>( false );
    const [isDisabled, setIsDisabled] = useState( false );
    const [showPasswordEyeIcon, setShowPasswordEyeIcon] = useState<boolean>( false );
    const [showConfirmPasswordEyeIcon, setShowConfirmPasswordEyeIcon] = useState<boolean>( false );

    function onChangeHandler( e: React.ChangeEvent<HTMLInputElement> ) {
        const { name, value } = e.target;
        if ( name === 'confirmPassword' ) setConfirmPassword( value );
        if ( name === 'password' ) setPassword( value );
        setPasswordError( '' );
        setConfirmPasswordError( '' );
    }

    async function resetPassword( e: React.UIEvent ) {
        try {
            setLoading( true );
            e.preventDefault();
            if ( password === '' ) {
                // util.toast.error( 'Please insert your password' );
                setPasswordError( 'Please insert your password' );
                setLoading( false );
                return;
            }
            else if ( confirmPassword === '' ) {
                // util.toast.error( 'Please insert your confirm password' );
                setConfirmPasswordError( 'Please insert your confirm password' );
                setLoading( false );
                return;
            }
            else if ( password.length < 8 ) {
                // util.toast.error( 'Please insert password of atleast 8 characters' );
                setPasswordError( 'Please insert password of atleast 8 characters' );
                setLoading( false );
                return;
            }
            else if ( confirmPassword.length < 8 ) {
                // util.toast.error( 'Please insert confirm password of atleast 8 characters' );
                setConfirmPasswordError( 'Please insert confirm password of atleast 8 characters' );
                setLoading( false );
                return;
            } else if ( password !== confirmPassword ) {
                // util.toast.error( 'Password and confirm password are not same' );
                setConfirmPasswordError( 'Password and confirm password are not same' );
                setLoading( false );
                return;
            }
            setIsDisabled( true );
            const request = await axios.post( `${baseUrl()}/csv-tool/reset/${searchParams.get( 'token' )}`, { password } );
            setLoading( false );
            const { error, msg } = request.data;
            if ( error ) {
                toast.error( msg );
            } else {
                toast.success( 'Confirmation email has been sent to your email address' );
                // setConfirmPassword('');
                // setPassword('')
                
                
                redirectToLogin();
            }
        } catch ( error: any ) {
            setIsDisabled( false );
            setLoading( false );
            handleError( error );
        }
    }

    function redirectToLogin() {
        delete_cookie( 'admin_pppcalc' );
        navigate( "/" );
        // window.history.replaceState( '', '', '/' );
        // window.location.reload();
    }

    return (
      <>
        <div className="container noauth-container">
            <div className="row">
                <div className="col-sm-12">
                    <div className="main-container">
                        {/* <div className="logo mb-3"><img src="/logo-min.png" /></div> */}
                        <div className="main-card">
                            <h1 className="text-center mb-4">{searchParams.get( 'set' ) == '1' ? 'Set' : 'Reset'} Password</h1>
                            <p className="text-center">{searchParams.get( 'email' )}</p>
                            {/* <p className="text-center">Please set me up with a new password</p> */}
                            {/* <p className="text-center">
                              To reset your password for <br /><strong>https://revrex.zendesk.com</strong>, enter your email <br />address and we'll send you an email with instructions.
                            </p> */}
                            <div className="mb-4">
                                <label>Password</label>
                                <div className='field-icon'>
                                    <input type={showPasswordEyeIcon ? 'text' : 'password'} className="form-control" onChange={onChangeHandler} name="password" value={password} />
                                    {
                                    showPasswordEyeIcon ? (
                                        <span className='pass-field-icon' onClick={() => setShowPasswordEyeIcon( false )}>
                                        <FontAwesomeIcon
                                        color='#978f8f'
                                        icon={faEye}
                                        className="iconGray isPointer ml-2"
                                        />
                                        </span>
                                    ) : (
                                        <span className='pass-field-icon' onClick={() => setShowPasswordEyeIcon( true )}>
                                        <FontAwesomeIcon
                                        color='#978f8f'
                                        icon={faEyeSlash}
                                        className="iconGray isPointer ml-2"
                                        />
                                        </span>
                                    )
                                    }
                                </div>
                                {/* <TextField
                                    variant="outlined"
                                    fullWidth
                                    label="Password"
                                    onChange={onChangeHandler}
                                    name="password"
                                    value={password}
                                    placeholder="Password"
                                    type="password"
                                /> */}

                                {passwordError && <FormErrorContainer nameError={passwordError} />}
                            </div>
                            <div className="mb-4">
                                {/* <TextField
                                    variant="outlined"
                                    fullWidth
                                    label="Confirm Password"
                                    onChange={onChangeHandler}
                                    name="confirmPassword"
                                    value={confirmPassword}
                                    placeholder="Confirm Password"
                                    type="password"
                                /> */}
                                <div className='field-icon'>
                                    <input type={showConfirmPasswordEyeIcon ? 'text' : 'password'} className="form-control" onChange={onChangeHandler} name="confirmPassword" value={confirmPassword} />
                                    {
                                    showConfirmPasswordEyeIcon ? (
                                        <span className='pass-field-icon' onClick={() => setShowConfirmPasswordEyeIcon( false )}>
                                        <FontAwesomeIcon
                                        color='#978f8f'
                                        icon={faEye}
                                        className="iconGray isPointer ml-2"
                                        />
                                        </span>
                                    ) : (
                                        <span className='pass-field-icon' onClick={() => setShowConfirmPasswordEyeIcon( true )}>
                                        <FontAwesomeIcon
                                        color='#978f8f'
                                        icon={faEyeSlash}
                                        className="iconGray isPointer ml-2"
                                        />
                                        </span>
                                    )
                                    }
                                    {confirmPasswordError && <FormErrorContainer nameError={confirmPasswordError} />}
                                </div>
                                
                            </div>
                            <div className="d-flex gap-3">
                                <Link to='/' className="revrex-outline-btn mr-3">Back to Login</Link>
                                <Link to='#' className="revrex-primary-btn" onClick={resetPassword}>Submit</Link>
                                {/* <a href="/" className="revrex-outline-btn mr-3">Back to Login</a>
                                <a href="#" className="revrex-primary-btn" onClick={resetPassword}>Submit</a> */}
                            </div>
                        </div>

                    </div>
                    <Footer />
                </div>
            </div>
        </div>
        {/* <SweetAlert
          show={showAlert}
          onCancel={() => redirectToLogin()}
          title="Confirmation email sent"
          text={`An email with instructions on how to reset your password has been sent to ${searchParams.get('email')}. Check your spam or junk folder if you don’t see the email in your inbox.`}
          onConfirm={() => redirectToLogin()}
        /> */}
        {/* <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        /> */}
        {loadingScreen( loading )}
      </>
    );
}

export default ResetPassword;
